import { getAppConfigSetting, requests } from 'utils';
import { URL } from './constants';

export function atlasAccountRestrictionsRequest(apexAccountId) {
  return requests.get(URL(getAppConfigSetting('legitUrl'), apexAccountId));
}



// WEBPACK FOOTER //
// ./src/services/atlasRequest/api.js